import React from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import "./utils/mixpanelWrapper";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import "react-filter-box-updated/lib/react-filter-box.css";

// This needs to come before the App import so all our sass throughout the app has precedence over
// the bootstrap styles.
import "./styleLoader.js";

import App from "./App";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import { reduxStore, createReduxStore } from "./redux";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_STAGE,
  integrations: [new Integrations.ExtraErrorData(), new Integrations.Dedupe()],
});

Sentry.setTag("amplify_build", process.env.REACT_APP_AWS_JOB_ID || "n/a");

// This is all related to CORS issues from running bpm-web in iframe. We can potentially get rid of
// this once we stop doing that.
if (!document.domain.endsWith("amplifyapp.com")) {
  try {
    document.domain = process.env.REACT_APP_DOMAIN;
  } catch (e) {
    // Setting document.domain seems to fail when loading our app in an iFrame, which I don't care
    // about.
    console.log(e.message);
  }
}

createReduxStore();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Cache kept for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnMount: false, // Don't refetch on component mount if data exists
      retry: 1, // Only retry failed requests once
    },
  },
});

ReactDOM.render(
  <Provider store={reduxStore}>
    <QueryClientProvider client={queryClient}>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root")
);
